import { ImageSlide, VideoSlide, AudioSlide, PdfSlide } from '../slides';
import { LOAD_AHEAD, SLIDE_TYPE } from '../constants';

const SlideMap = {
    [SLIDE_TYPE.IMAGE]: ImageSlide,
    [SLIDE_TYPE.VIDEO]: VideoSlide,
    [SLIDE_TYPE.AUDIO]: AudioSlide,
    [SLIDE_TYPE.PDF]: PdfSlide,
};

const shouldPreloadSlide = (index, activeIndex) => index > activeIndex && index <= activeIndex + LOAD_AHEAD;

const pickSlideComponent = (type) => SlideMap[type];

export { shouldPreloadSlide, pickSlideComponent };
